import "./styles/_main.scss";
host.plugins.register({
    // #region Vars
    name: "288a.ecommerce.catalog",
    // #endregion
    // #region Register
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
    }
    // #endregion
});
